// pledges
import gift from "./images/quote-gift.png";
import mistakes from "./images/quote-mistakes.png";
import noLimit from "./images/quote-no-limit.png";

// red theme
import redFaces from "./images/red-faces.png";
import redUpload from "./images/red-upload.png";
import redIGSFaces from "./images/IGS-red-faces.png";
import redIGSUpload from "./images/IGS-red-upload.png";

// navy theme
import navyFaces from "./images/navy-faces.png";
import navyPledge1 from "./images/navy-pledge-1.png";
import navyPledge2 from "./images/navy-pledge-2.png";
import navyPledge3 from "./images/navy-pledge-3.png";
import navyUpload from "./images/navy-upload.png";
import navyIGSFaces from "./images/IGS-navy-faces.png";
import navyIGSUpload from "./images/IGS-navy-upload.png";

// teal theme
import tealFaces from "./images/teal-faces.png";
import tealUpload from "./images/teal-upload.png";
import tealIGSFaces from "./images/IGS-teal-faces.png";
import tealIGSUpload from "./images/IGS-teal-upload.png";

const themes = {
  pledges: {
    btnClassName: "green-option-btn",
    img1: navyPledge1,
    img2: navyPledge2,
    img3: navyPledge3,
    img1Quote: noLimit,
    img2Quote: gift,
    img3Quote: mistakes,
    alt1: "I pledge to support every student's potential in math! I, your name here, will tell my students there is no limit to their math achievement!",
    alt2: "I pledge to support every student's potential in math! I, your name here, will tell my students that the gift of math is for all of them.",
    alt3: "I pledge to support every student's potential in math! I, your name here, will tell my students that mistakes are part of growing.",
    btn1: "OPTION ONE",
    btn2: "OPTION TWO",
    btn3: "OPTION THREE",
  },
  red: {
    facesBG: redFaces,
    uploadBG: redUpload,
    facesIGS: redIGSFaces,
    uploadIGS: redIGSUpload,
  },
  navy: {
    facesBG: navyFaces,
    uploadBG: navyUpload,
    facesIGS: navyIGSFaces,
    uploadIGS: navyIGSUpload,
  },
  teal: {
    facesBG: tealFaces,
    uploadBG: tealUpload,
    facesIGS: tealIGSFaces,
    uploadIGS: tealIGSUpload,
  },
};

export default themes;
